import { Centre } from '../../../../types/contentful-v1'
import { Segment } from '../types'

const HEADINGS = {
  categories: 'Categories',
  topStores: 'Top Stores',
  products: 'Products',
  westfieldServices: 'Westfield Services',
  offers: 'Offers',
  events: 'Events',
  news: 'News',
  stories: 'Story',
  centres: 'Centres',
  nearbyStores: 'Other nearby stores',
  nearCentreStores: 'Other stores',
}

type HeadingName = keyof typeof HEADINGS

const getSegmentsToHeadings = (
  headings: Record<HeadingName, string>
): Record<Segment, string> => ({
  retailers: headings.topStores,
  stores: headings.topStores,
  sites: headings.westfieldServices,
  services: headings.westfieldServices,
  offers: headings.offers,
  events: headings.events,
  news: headings.news,
  localStories: headings.stories,
  nationalStories: headings.stories,
  centres: headings.centres,
  onlineServices: headings.westfieldServices,
  nearCentreStores: headings.nearCentreStores,
  products: headings.products,
  categories: headings.categories,
})

const headingsForCentre = (
  headings: Record<HeadingName, string>,
  centre?: Centre
): Record<HeadingName, string> => {
  const centreHeadings = { ...headings }
  if (centre) {
    centreHeadings.nearCentreStores += ` near ${centre.title}`
  }
  return centreHeadings
}

interface HeadingInfo {
  getHeadingForSegment: (s: Segment) => string
  headingsToDisplay: string[]
}

export function makeHeadingInfo(centre?: Centre): HeadingInfo {
  const headings = headingsForCentre(HEADINGS, centre)
  const segmentToHeadings = getSegmentsToHeadings(headings)
  const getHeadingForSegment = (segment: Segment): string =>
    segmentToHeadings[segment]
  const headingsToDisplay = Object.values(headings)
  return { getHeadingForSegment, headingsToDisplay }
}
